<template>
    <div id="app">
		
        <router-view />
    </div>
</template>
<script>


	export default {


	};
</script>

<style lang="scss">
    .position-relative {
        position: relative;
    }

    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.5);
    }

    .pre-venda-text {
        position: absolute;
        top: 41%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-41deg);
        font-size: 3.3em;
        font-family: cursive, sans-serif;
        font-weight: bold;
        background-color: #db994b;
        color: #f70c0c;
        text-align: center;
        white-space: nowrap;
    }
</style>
